import { writable } from 'svelte/store';
export const storeBackendUrl = writable("");
export const storeAccessToken = writable("");
export const storeError = writable("");
// Utile entre la redirection et la création du nouveau password
export const storeTokenReinitPassword = writable("");
export const storeIsPodcastDisplayed = writable(false);
